module.exports = __webpack_public_path__ + "ddba11e1a0cb73922adb539d567b81bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/page-header/bg-header.png
// module id = ./src/components/page-header/bg-header.png
// module chunks = index